export const mapSquareFootageToSize = (sqft?: number | null): string => {
  if (!sqft) return ''
  if (sqft < 1000) return 'apartment'
  if (sqft <= 2500) return 'small'
  return 'large'
}
